var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8 16.9H0.2C0.08954 16.9 0 16.8105 0 16.7V15.6C0 15.4895 0.08954 15.4 0.2 15.4H17.8C17.9105 15.4 18 15.4895 18 15.6V16.7C18 16.8105 17.9105 16.9 17.8 16.9ZM13.1152 0.06526C13.0725 0.0225 13.0163 0 12.9555 0C12.8948 0 12.8385 0.0225 12.7957 0.06526L10.3718 2.48922C10.2937 2.56732 10.2937 2.69396 10.3718 2.77206L11.1496 3.54988C11.2277 3.62798 11.3543 3.62798 11.4324 3.54988L12.9552 2.02708L14.8923 3.96536L6.54027 12.3174L4.19045 12.7295L4.60259 10.3797L9.38183 5.6005C9.85047 5.13186 9.85047 4.37206 9.38183 3.90344L9.31113 3.83272C9.23301 3.75462 9.10639 3.75462 9.02827 3.83272L3.25801 9.603C3.22425 9.63676 3.20399 9.67724 3.19501 9.72224L2.53125 13.5068C2.48851 13.7565 2.56501 13.9995 2.74275 14.1772C2.89125 14.3213 3.07801 14.4 3.27825 14.4C3.32325 14.4 3.36825 14.3955 3.41325 14.3888L7.19775 13.725C7.24275 13.716 7.28551 13.6957 7.31701 13.662L16.8547 4.12424C16.9425 4.0365 16.9425 3.89474 16.8547 3.807L13.1152 0.06526Z",
    fill: "#367878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPen);
export default __webpack_public_path__ + "static/media/icon-pen.09c305feefde31dfb9c1d00d90408cc6.svg";
export { ForwardRef as ReactComponent };